/**
 * Created by andrewstirling on 20/6/17.
 */

import React, { Component } from 'react';
import CustomerLoginsRow from './customer-logins-row'
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

export default class CustomerLogins extends Component {
    state = {
        errorMessage: null,
        showModal: false,
        resendEmail: null
    }

    closeModal = () => {
        if( this.state.errorMessage )
            this.setState({errorMessage: null});
        else {
            this.setState({showModal: false});
        }
    };

    openModal = (email) => {
        this.setState({ showModal: true, resendEmail: email });
    };

    openErrorModal = (errorMessage) => {
        this.setState({ errorMessage: errorMessage})
    };

    render() {
        const logins = this.props.loginList.map(login => <CustomerLoginsRow key={login._id} login={login} openModal={this.openModal} openErrorModal={this.openErrorModal}/>);
        const { showModal, resendEmail, errorMessage } = this.state

        return (
            <div className="customer-logins-main-div">
                <Modal show={showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Resend activation email</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div><p>A new activation email has been successfully sent to <b>{resendEmail}</b>.</p></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="primary" bsSize="large" onClick={this.closeModal}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={errorMessage?true:false} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error while resending the activation code</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div><p style={{color: "red"}}>{errorMessage}</p></div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsStyle="primary" bsSize="large" onClick={this.closeModal}>Close</Button>
                    </Modal.Footer>
                </Modal>
                <div className="each-customer-info">
                    <div className="col-lg-12 col-sm-12 personal-info">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="bluedotColor">
                                    <tr>
                                        <th><label>User name</label></th>
                                        <th><label>First name</label></th>
                                        <th><label>Last name</label></th>
                                        <th><label>Admin</label></th>
                                        <th><label>Activated</label></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {logins}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        ); // return
    } // render
} // CustomerLogins